var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._t("default"),
      _vm._v(" "),
      _vm.success
        ? _c("div", { attrs: { id: "successMsg" } }, [_vm._v(_vm._s(_vm.msg))])
        : _vm.failure
        ? _c("div", [
            _vm._v("Whoopsie...that didn't work. Are you "),
            _c("a", { attrs: { href: "/login/" } }, [_vm._v("logged in")]),
            _vm._v("?"),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", [
        _c("input", {
          attrs: { type: "button", value: "Add", text: "Add" },
          on: {
            click: function ($event) {
              return _vm.submitForm()
            },
          },
        }),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }